<template>
  <div class="listInfo">
    <el-card class="box-card" style="height:100%">
      <div slot="header"   class="clearfix">
        <span class="clearfix-sapn">{{name}}</span>
      </div>
      <div class="text">
        <el-form ref="form" label-width="120px">
          <el-form-item :label="item.key"  class="item" v-for="item in form" :key="item.index">
            <span v-if='item.value ===true' @click="modify" class="content_cursor"><i class="el-icon-circle-check"></i></span>
            <span v-else-if='item.value ===false' @click="modify" class="content_cursor"><i class="el-icon-circle-close"></i></span>
            <span v-else class="content">{{item.value}}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-card>   
  </div>
</template>

<script>
export default {
  props: {
    form: Array,
    name: String,
    type: String
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 点击标题跳转修改页面
     */
    modify(){
      if( this.type== 'qualified'){
         this.$router.push({
          path: '/index/user/qualifications'
        });
      }else if( this.type =='realauth'){
         this.$router.push({
          path: '/index/user/authentication'
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.listInfo {
  height: 100%;
  .item:nth-child(1){
    .content{
      color:#FF0000;
    }
  }
  .item:nth-child(2){
    .content{
      color:#FF0000;
    }
  }
  .item:nth-child(3){
    .content{
      color:#FC701A;
    }
  }
}
.el-form-item__label {
  float: left;
}
.content {
  float: right;
}
.content_cursor {
  float: right;
  cursor:pointer;
}

.listInfo .el-icon-circle-check{
  font-size: 20px;
  color: #019E4E;
}
.listInfo .el-icon-circle-close{
  font-size: 20px;
  color: red;
}
 .listInfo .clearfix-sapn{
   border-left: 3px solid #FC9710;
   padding-left: 5px;
 }
</style>
